import { css as i, styled as t } from "styled-components";
import { MediaQuery as r } from "../variables.js";
import { ColorsCSSVariables as a } from "../themes/index.js";
const p = i`
  @media ${r.SCREEN_MD_UP} {
    min-width: 391px;
  }
`, c = t.div`
  display: content;
  ${a.DARK}
`, d = (e, o) => i`
  max-height: calc(${o}rem * ${e});
  -webkit-line-clamp: ${e};
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
export {
  c as DarkThemeWrapperContainer,
  d as clampMixin,
  p as mediumScreenModalStyle
};
